import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const MeetCounselorSC = styled.div`
    max-width: 1100px;
    margin: 0 auto;
    padding: 40px 20px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, sans-serif;

     ${NoTextSelectionStyles}
    .mentor-title {
        font-size: 24px;
        width: 320px;
        text-align: center;
        font-weight: 700;
        margin-bottom: 24px;
        letter-spacing: 1px;
    }

    .mentor-card {
        display: flex;
        gap: 32px;
        align-items: flex-start;
    }

    .mentor-profile {
        width: 280px;
        border: 1px solid #ddd;
        border-radius: 12px;
        padding: 16px;
        text-align: center;
    }

    .mentor-image-wrapper {
        border-radius: 12px;
    }

    .mentor-image {
        width: 100%;
        border-radius: 8px;
    }

    .mentor-name {
        margin-top: 16px;
        font-size: 18px;
        font-weight: 700;
    }

    .mentor-role {
        color: #666;
        font-size: 14px;
        margin-top: 4px;
    }

    .mentor-content {
        flex: 1;
        font-size: 18px;
        line-height: 1.6;
        color: #222;
        margin-top: -20px;
        text-align: justify;
    }

    .mentor-content p {
        margin-bottom: 14px;
    }

    @media (max-width: 768px) {
        max-width: unset;
        width: 100%;
        padding: 24px 0px;
        margin: 0px;

        .mentor-title {
            font-size: 16px;
            width: 100%;
            text-align: center;
            font-weight: 700;
            margin-bottom: 18px;
        }

        .mentor-card {
            display: flex;
            gap: 14px;
            width: 100%;
            flex-direction: column;
            align-items: center;
        }

        .mentor-profile {
            width: 220px;
        }

        .mentor-name {
            margin-top: 14px;
            font-size: 14px;
            font-weight: 600;
        }

        .mentor-role {
            color: #666;
            font-size: 14px;
            margin-top: 4px;
        }

        .mentor-content {
            width: 80%;
            font-size: 14px;
            margin-top: -8px;
        }

        .mentor-content p {
            margin-bottom: -4px;
        }
    }
`;

export default MeetCounselorSC;